import { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`
  :root{
    --brand-main-color: ${({ theme }) => theme.colors.mainColor};
  }

  .header {
      border-top : ${({ theme }) => theme.colors.headerBorder + ' !important'}
  }

  .logo-content img{
      height : ${({ theme }) => theme.logoContent + ' !important'}
  }

  .select *{
      color :${({ theme }) => theme.colors.text + ' !important;'}
      border : ${({ theme }) => '1px solid ' + theme.colors.text + ' !important;'}
  }

  .title-card {
      background : ${({ theme }) => theme.colors.background + ' !important'}
  }
  
  .bottom-text{
      color : ${({ theme }) => theme.colors.mainColor + ' !important'}
  }

  .btn-primary {
    background : ${({ theme }) => theme.colors.mainColor + ' !important'}
  }

  .button a *{
    color : ${({ theme }) => theme.colors.mainColor + ' !important'}
  }
  
  .service-content{
      background : ${({ theme }) => theme.colors.serviceContentBackground + ' !important'}
  }

  .footer {
      background : ${({ theme }) => theme.colors.footer + ' !important'}
  }

  .information-table .tdata , .information-table .trow , .information-title{
      color : ${({ theme }) => theme.colors.text + ' !important'}
  }

  .information-title{
    font-family : ${({ theme }) => theme?.fonts?.mainText + ' !important'};
    font-weight : bold !important;
  }

  .trow{
    font-family : ${({ theme }) => theme?.fonts?.subText + ' !important'};
    font-weight : 600;
  }

  .tdata{
    font-family : ${({ theme }) => theme.fonts.subText + ' !important'};
    font-weight : normal !important;
  }

  .information-table:nth-child(even){
    background-color : ${({ theme }) => theme.colors.tRow + ' !important'}
  }
  
  .card-sub-text , .service-logs p , .support-text-title , .support-text-sub-title,.card-main-text{
      color : ${({ theme }) => theme.colors.cardText + ' !important'}
  }

  .main-text{
    font-family : ${({ theme }) => theme.fonts.mainText + ' !important'};
    font-weight : 500;
  }

  .registration-text{
    font-family : ${({ theme }) => theme.fonts.subText + ' !important'};
    font-weight : normal;
  }

  .center-texts .sub-text{
    font-family : ${({ theme }) => theme.fonts.subText + ' !important'};
    font-weight : normal;
  }
  
  .css-g239ip-MuiTypography-root{
      color : ${({ theme }) => theme.colors.text + ' !important'};
  }

  .select *{
    font-family : ${({ theme }) => theme.fonts.subText + ' !important'};
    font-weight : normal;
  }

  .modal-title{
    font-family : ${({ theme }) => theme.fonts.mainText + ' !important'};
    font-weight : 500;
  }

  .modal-sub-title{
    font-family : ${({ theme }) => theme.fonts.subText + ' !important'};
    font-weight : normal;
  }

  .card-text{
    font-family : ${({ theme }) => theme.fonts.mainText + ' !important'};
    font-weight : normal;
  }

  .card-main-text{
      font-family : ${({ theme }) => theme.fonts.mainText + ' !important'};
      font-weight : bold !important;
  }

  .card-sub-text{
    font-family : ${({ theme }) => theme.fonts.subText + ' !important'}
  }
  
  .register-text{
      font-family : ${({ theme }) => theme.fonts.mainText + ' !important'}
  }

  .register-sub-text{
    font-family : ${({ theme }) => theme.fonts.subText + ' !important'}
  }

  .btn{
    font-family : ${({ theme }) => theme.fonts.subText + ' !important'};
    font-weight : normal;
  }

  .bottom-text{
    font-family : ${({ theme }) => theme.fonts.subText + ' !important'}
  }

  .title{
    font-family : ${({ theme }) => theme.fonts.mainText + ' !important'};
    font-weight : bold !important;
  }

  .service-logs .log-title{
    font-family : ${({ theme }) => theme?.fonts?.subText + ' !important'};
    font-weight : 600;
  }

  .service-logs .log-text{
    font-family : ${({ theme }) => theme.fonts.subText + ' !important'};
    font-weight : normal;
  }

  .support-text-title{
    font-family : ${({ theme }) => theme.fonts.mainText + ' !important'};
    font-weight : 500;
  }
  
  .support-text-sub-title{
    font-family : ${({ theme }) => theme.fonts.subText + ' !important'};
    font-weight : normal;
  }

  .contact-content * , .more-support *{
    font-family : ${({ theme }) => theme.fonts.subText + ' !important'};
    font-weight : 700;
  }

  .links a {
    font-family : ${({ theme }) => theme.fonts.subText + ' !important'};
    color : ${({ theme }) => theme.colors.cardText + ' !important'}
  }


  .hmpg-title{
    font-family : ${({ theme }) => theme.fonts.mainText + ' !important'};
  }

  .hmpg-sub-title , .hmpg-mini-sub-title , .error , .button, .info-label , .hmpg-input-content input , .select {
    font-family : ${({ theme }) => theme.fonts.subText + ' !important'};
  }

  .footer-text{
    color : ${({ theme }) => theme.colors.footerText + ' !important'};
  }
`;